import React, { useState } from 'react';
import { Stack, LinearProgress, useTheme, useMediaQuery } from '@mui/material';
import CarouselLeftArrow from '../../assets/icons/CarouselLeftArrow';
import CarouselRightArrow from '../../assets/icons/CarouselRightArrow';
import Animation1 from '../../assets/Images/animation.webp';
import Animation2 from '../../assets/Images/animation (1).webp';
import Animation3 from '../../assets/Images/animation (2).webp';
import Animation4 from '../../assets/Images/animation (3).webp';
import Animation5 from '../../assets/Images/animation (4).webp';
import Animation6 from '../../assets/Images/animation (5).webp';
import Animation7 from '../../assets/Images/animation (6).webp';
import Animation8 from '../../assets/Images/animation (7).webp';
import Animation9 from '../../assets/Images/animation (8).webp';
import Animation10 from '../../assets/Images/animation (9).webp';
import MobileAnimation1 from '../../assets/Images/mobile carousel.webp';
import MobileAnimation2 from '../../assets/Images/mobile carousel (1).webp';
import MobileAnimation3 from '../../assets/Images/mobile carousel (2).webp';
import MobileAnimation4 from '../../assets/Images/mobile carousel (3).webp';
import MobileAnimation5 from '../../assets/Images/mobile carousel (4).webp';
import MobileAnimation6 from '../../assets/Images/mobile-carousel (5).webp';
import MobileAnimation7 from '../../assets/Images/mobile carousel (6).webp';
import MobileAnimation8 from '../../assets/Images/mobile carousel (7).webp';
import MobileAnimation9 from '../../assets/Images/mobile carousel (8).webp';
import MobileAnimation10 from '../../assets/Images/mobile carousel (9).webp';
import Slider from 'react-slick';
import DisabledCarouselRightArrow from '../../assets/icons/DisabledCarouselRightArrow';
import DisabledCarouselLeftArrow from '../../assets/icons/DisabledCarouselLeftArrow';

const CarouselCard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const matches = useMediaQuery('(max-width:1439px)');
    const carousels = [
        Animation1,
        Animation2,
        Animation3,
        Animation4,
        Animation5,
        Animation6,
        Animation7,
        Animation8,
        Animation9,
        Animation10
    ];
    const MobileCarousels = [
        MobileAnimation1,
        MobileAnimation2,
        MobileAnimation3,
        MobileAnimation4,
        MobileAnimation5,
        MobileAnimation6,
        MobileAnimation7,
        MobileAnimation8,
        MobileAnimation9,
        MobileAnimation10
    ];
    const [progress, setProgress] = useState(10);
    const [position, setPosition] = useState('start');
    const settings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 500,
        cssEase: 'linear',
        nextArrow: isMobile ? (
            <></>
        ) : position === 'end' ? (
            <DisabledCarouselRightArrow />
        ) : (
            <CarouselRightArrow />
        ),
        prevArrow: isMobile ? (
            <></>
        ) : position === 'start' ? (
            <DisabledCarouselLeftArrow />
        ) : (
            <CarouselLeftArrow />
        ),
        beforeChange: (currentSlide: number, nextSlide: number) => {
            if (nextSlide > currentSlide) {
                setProgress((prev) => prev + 10);
            } else if (nextSlide < currentSlide) {
                setProgress((prev) => prev - 10);
            }
        },
        afterChange: (currentSlide: number) => {
            if (currentSlide === 9) {
                setPosition('end');
            } else if (currentSlide > 0) {
                setPosition('');
            } else if (currentSlide === 0) {
                setPosition('start');
                setProgress(10);
            }
        }
    };

    return (
        <Stack position="relative" gap={isMobile ? '24px' : '89px'}>
            <Stack width="100%" maxWidth={matches ? '2000px' : '874px'}>
                {isMobile ? (
                    <Slider {...settings}>
                        {MobileCarousels.map((carousel) => (
                            <Stack key={carousel}>
                                <img
                                    style={{
                                        width: '100%'
                                    }}
                                    src={carousel}
                                    alt="slideshow"
                                />
                            </Stack>
                        ))}
                    </Slider>
                ) : (
                    <Slider {...settings}>
                        {carousels.map((carousel) => (
                            <Stack key={carousel}>
                                <img
                                    style={{
                                        width: '100%'
                                    }}
                                    src={carousel}
                                    alt="slideshow"
                                />
                            </Stack>
                        ))}
                    </Slider>
                )}
            </Stack>
            <Stack maxWidth={matches ? '2000px' : '874px'}>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        backgroundColor: '#D9D9D9',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: 'primary.yellow'
                        }
                    }}
                />
            </Stack>
        </Stack>
    );
};

export default CarouselCard;
